// Funções puras extraídas de UserAdminModal.jsx (issue 012, docs/07-issues.md)
// — sem estado, sem JSX, sem hooks. Movidas pra cá pra reduzir o tamanho do
// arquivo principal; comportamento idêntico, só mudou de arquivo.
import styles from "../UserAdminModal.module.css";

export const ROLE_LABELS = {
  admin: "Administrador",
  professor: "Professor",
  aluno: "Aluno",
  google: "Google"
};

// Mesma regra de app/services/org_access.py::can_manage_student no lado do
// professor: o responsável sempre; dentro de uma academia, qualquer
// professor dela (rodízio). O backend continua sendo quem decide de verdade.
export function canProfessorManageStudent(professor, student) {
  if (!professor || !student || student.role !== "aluno") return false;
  if (student.professor_id === professor.id) return true;
  return !!(professor.organization_id && professor.org_role
    && student.organization_id === professor.organization_id);
}

export function getRoleBadgeClass(role) {
  if (role === "admin") return styles.roleAdmin;
  if (role === "professor") return styles.roleProfessor;
  return styles.roleAluno;
}

export const BRAND_PRESETS = [
  { hex: "#1d9e75", label: "Verde (padrão)" },
  { hex: "#10b981", label: "Verde vivo" },
  { hex: "#059669", label: "Esmeralda" },
  { hex: "#84cc16", label: "Lima" },
  { hex: "#14b8a6", label: "Teal" },
  { hex: "#22d3ee", label: "Ciano claro" },
  { hex: "#06b6d4", label: "Ciano" },
  { hex: "#0ea5e9", label: "Céu" },
  { hex: "#38bdf8", label: "Azul claro" },
  { hex: "#2563eb", label: "Azul" },
  { hex: "#6366f1", label: "Índigo" },
  { hex: "#8b5cf6", label: "Violeta" },
  { hex: "#a855f7", label: "Roxo" },
  { hex: "#d946ef", label: "Fúcsia" },
  { hex: "#f43f5e", label: "Rosa" },
  { hex: "#fb923c", label: "Coral" },
  { hex: "#ef4444", label: "Vermelho" },
  { hex: "#f97316", label: "Laranja" },
  { hex: "#f59e0b", label: "Âmbar" },
  { hex: "#d97706", label: "Dourado" },
  { hex: "#eab308", label: "Amarelo" },
  { hex: "#6b7280", label: "Grafite" },
  { hex: "#94a3b8", label: "Prata" },
  { hex: "#e2e8f0", label: "Branco" },
];

export function getEmptyUserForm() {
  return {
    name: "",
    email: "",
    password: "",
    role: "aluno",
    professor_id: "",
    weekly_goal: "3",
    is_active: true,
    plan_expires_at: "",
    brand_color: "",
    brand_bg_color_dark: "",
    brand_bg_color_light: "",
    is_self_service: false,
    student_billing_override: false,
    organization_name: "",
  };
}

export function getEmptyPasswordForm() {
  return {
    current_password: "",
    new_password: "",
    confirm_password: "",
  };
}

// fora do componente (estável)
export function buildImageSrc(path, apiBase) {
  if (!path) return "";

  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  if (!apiBase) {
    return `/${path}`.replace(/\/+/g, "/");
  }

  return `${apiBase}/${path}`.replace(/([^:]\/)\/+/g, "$1");
}

export function getUserLabel(role) {
  if (role === "admin") {
    return {
      title: "Administrar usuários",
      button: "Novo usuário",
      list: "Nenhum usuário encontrado",
    };
  }

  if (role === "professor") {
    return {
      title: "Gerenciar alunos",
      button: "Novo aluno",
      list: "Nenhum aluno encontrado",
    };
  }

  return {
    title: "Meu perfil",
    button: "Novo usuario",
    list: "Nenhum usuario encontrado",
  };
}
